import { useCallback, useContext, useEffect, useState } from "react";
import { Row, Col, Divider, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import Tab from "./tab";
import Welcome from "./welcome";
import LoadSkeleton from "../app/generic/loadSkeleton";
import { getEntity } from "../../modules/crudOperations";
import { FingerprintContext } from "../fingerprintProvider";

const { Paragraph } = Typography;

const Choice = () => {
  const fingerprint = useContext(FingerprintContext);

  const [loading, setLoading] = useState();
  const [oldContract, setOldContract] = useState();
  const handleLoadOld = useCallback(() => {
    fingerprint &&
      getEntity("contract", fingerprint, setLoading, setOldContract, {
        choice: true,
      });
  }, [fingerprint]);

  useEffect(() => {
    handleLoadOld();
  }, [handleLoadOld]);

  const navigate = useNavigate();
  const handleNewClick = useCallback(() => {
    navigate("form");
  }, [navigate]);
  const handleOldClick = useCallback(() => {
    oldContract && navigate(`form/${oldContract.id}`);
  }, [navigate, oldContract]);

  return (
    <Row justify="center">
      <Col xl={12} xs={22}>
        <Welcome />
        <Divider />
        {loading ? (
          <LoadSkeleton />
        ) : oldContract && oldContract !== "e" ? (
          <>
            <Tab contract={oldContract} onClick={handleOldClick} />
            <Divider />
          </>
        ) : (
          <></>
        )}
        <Tab onClick={handleNewClick} />
        <Divider />
        <Paragraph className="center">
          <FormattedMessage
            id="welcome.help"
            defaultMessage="V případě problému kontaktuje zákaznický servis na tel: +420 239 018 222 nebo na e-mailu: DHLFreight.CZ@dhl.com."
          />
        </Paragraph>
      </Col>
    </Row>
  );
};

export default Choice;
